import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShiftRouteSelectionComponent } from './components/shift-route-selection/shift-route-selection.component';
import { RouteReplayComponent } from './components/route-replay/route-replay.component';
import { routeReplayResolver } from './resolvers/route-replay.resolver';

const routes: Routes = [
  {
    path: '',
    component: ShiftRouteSelectionComponent
  },
  {
    path: 'shuttle/routes',
    component: RouteReplayComponent,
    resolve: routeReplayResolver
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RouteReplayRoutingModule { }